import { useGateValue } from '@statsig/react-bindings';

export const FEDEX_PICKUP_GATE = 'fedex_pickup_scheduling';

export function useFedExPickupGate(): boolean {
  return useGateValue(FEDEX_PICKUP_GATE);
}
